// Bernie
import { AnalyticsStore, codeSplit, Controller, FetchOptions, Result } from 'bernie-core';
import { PageData } from 'bernie-http';

// Data
import { pageNames } from 'data/page-names';

// Stores
import { UiStore } from 'stores';

// Utils
import analyticsUtil from '../util/AnalyticsUtil';

class ExpediaPackageController implements Controller {
  public bundles = [];

  public component = codeSplit(
    () => import(/* webpackChunkName: "expedia-package-page" */ '../views/expedia-package-page'),
  );

  public pageId = pageNames.expediaPackage;

  public path = '/:localeName/expedia-package';
  public exact = true;

  public routeName = 'expedia-package';

  public fetch(options: FetchOptions) {
    const { stores, request } = options;

    const analyticsStore: AnalyticsStore = stores?.get<AnalyticsStore>('analytics');

    const uiStore = stores?.get<UiStore>('uiStore');
    uiStore?.setPageName(this.pageId);

    analyticsUtil.runAnalytics(this.pageId, analyticsStore, request.context);

    return Promise.resolve(Result.ok());
  }

  public fetchPageData() {
    const pageData: PageData = {
      title: 'Expedia Package Deals Widget',
    };

    return Promise.resolve(pageData);
  }
}

export { ExpediaPackageController };
